import { render, staticRenderFns } from "./reviseMask.vue?vue&type=template&id=14c20227&scoped=true&"
import script from "./reviseMask.vue?vue&type=script&lang=js&"
export * from "./reviseMask.vue?vue&type=script&lang=js&"
import style0 from "./reviseMask.vue?vue&type=style&index=0&id=14c20227&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c20227",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VDialog,VIcon,VTreeview})
